import React, { useMemo } from 'react';
import { EonUiSegmentedButtonGroup, EonUiSegmentedButton, EonUiStatePill } from '@eon-ui/eon-ui-components-react';
import { SET_TIMELINE_FILTER } from '../../scripts/GlobalContextProvider';
import { useGlobalYear, useGlobalAvailableYears, useGlobalDispatch } from '../../scripts/useGlobalState';
import { CURRENT_YEAR } from '../../scripts/utils';
import './index.scss';

const Timeline = () => {
  const globalDispatchContext = useGlobalDispatch();
  const year = useGlobalYear();
  const availableYears = useGlobalAvailableYears();

  const marks = useMemo(() => {
    if (!Array.isArray(availableYears) || availableYears.length === 0) {
      return [];
    }

    return availableYears.map((availableYear) => ({
      value: availableYear,
      label: availableYear > CURRENT_YEAR ? `${availableYear} (Prognose)` : String(availableYear),
    }));
  }, [availableYears]);

  return marks.length > 0 && (
    <section className="timeline">
      {marks.length === 1 ? (
        <EonUiStatePill
          label={marks[0].label}
          scheme='inactive'
          bold
        />
      ) : (
        <EonUiSegmentedButtonGroup size='small'>
          {marks.map(({ value, label }, index) => (
            <EonUiSegmentedButton
              firstItem={index === 0}
              lastItem={index === marks.length - 1}
              key={`${index}${label}`}
              value={value}
              label={label}
              checked={year === value}
              onClick={() => globalDispatchContext({ type: SET_TIMELINE_FILTER, payload: value })}
              size='small'
            />
          ))}
        </EonUiSegmentedButtonGroup>
      )}
    </section>
  );
};

export default React.memo(Timeline);